/**
 * ImagesService
 * @module Services/domain/ImagesService
 * @description Offers a set of methods to help with images
 */

import HttpService from "../http/HttpService";

const self = {};

/**
 * Uploads an image
 * @author Sameh Bellez
 * @alias upload
 * @param request {object} the file to upload
 * @memberof module:Services/domain/ImagesService
 * @returns {promise}  The upload result
 */
self.upload = (url, file) => {
  const formData = new FormData();
  formData.append("image", file);

  return HttpService().post(url, formData, {
    'Content-Type': 'multipart/form-data'
  }).then(result => result.image);
};


export default self;